import { get, put } from "../axios";

// 系统配置-列表
export const sysConfigList = (params) => get("/web/sys/config/list", params);

// 系统配置-编辑
export const sysConfigUpdate = (params) =>
  put("/web/sys/config/update", params);
